import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import GoogleMapReact from "google-map-react"
import { Tooltip } from "reactstrap"
import { Link } from "gatsby"

import "./styles.less"

const K_CIRCLE_SIZE = 200
const K_STICK_SIZE = 220

function mapOptionsCreator(map) {
  return {
    zoomControlOptions: {
      position: map.ControlPosition.LEFT_TOP,
    },
    styles: [
      {
        featureType: "water",
        elementType: "labels.text",
        stylers: [
          {
            color: "#959595",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#d3d3d3",
          },
        ],
      },
      {
        featureType: "transit",
        stylers: [
          {
            color: "#808080",
          },
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#b3b3b3",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#ffffff",
          },
          {
            weight: 1.8,
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#d7d7d7",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#ebebeb",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "geometry",
        stylers: [
          {
            color: "#a7a7a7",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#efefef",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#696969",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#999999",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#d6d6d6",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {},
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#dadada",
          },
        ],
      },
    ],
  }
}

const Map = ({
  children,
  center = {
    lat: 43.7184038,
    lng: -79.5181406,
  },
  ...props
}) => {
  const distanceToMouse = (markerPos, mousePos, markerProps) => {
    const x = markerPos.x
    // because of marker non symmetric,
    // we transform it central point to measure distance from marker circle center
    // you can change distance function to any other distance measure
    const y = markerPos.y - K_STICK_SIZE - K_CIRCLE_SIZE / 2

    // and i want that hover probability on markers with text === 'A' be greater than others
    // so i tweak distance function (for example it's more likely to me that user click on 'A' marker)
    // another way is to decrease distance for 'A' marker
    // this is really visible on small zoom values or if there are a lot of markers on the map
    const distanceKoef = markerProps.text !== "A" ? 1.5 : 1

    // it's just a simple example, you can tweak distance function as you wish
    return (
      distanceKoef *
      Math.sqrt(
        (x - mousePos.x) * (x - mousePos.x) +
          (y - mousePos.y) * (y - mousePos.y)
      )
    )
  }

  return (
    <GoogleMapReact
      bootstrapURLKeys={{ key: process.env.GATSBY_GOOGLE_MAPS_API_KEY }}
      hoverDistance={30}
      distanceToMouse={distanceToMouse}
      options={mapOptionsCreator}
      defaultZoom={12}
      defaultCenter={{
        lat: 43.7184038,
        lng: -79.548141,
      }}
      center={center}
      {...props}
    >
      {children}
    </GoogleMapReact>
  )
}
const Marker = ({
  text,
  selected = false,
  url = false,
  slug = false,
  className = "",
  id,
  isActive = false,
  priceRange = null,
  isHqSuite = false,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)

  const toggle = () => setTooltipOpen(!tooltipOpen)

  useEffect(() => {
    setTooltipOpen(!!isActive)
  }, [isActive])

  return (
    <p
      className={`${
        selected ? "map-marker active" : "map-marker "
      } ${className}`}
    >
      {url && (
        <a href={url} rel="noopener noreferrer">
          {priceRange ? (
            <span id={`marker_${id}`}>{priceRange}</span>
          ) : (
            <img
              src={
                isHqSuite
                  ? require("../../images/icons/map-marker-hq-suites.svg")
                      .default
                  : require("../../images/icons/map-marker.svg").default
              }
              alt={text}
              id={`marker_${id}`}
              className={"custom-map-marker"}
            />
          )}
          <Tooltip
            placement="top"
            isOpen={tooltipOpen}
            target={`marker_${id}`}
            toggle={toggle}
          >
            {text}
          </Tooltip>
        </a>
      )}
      {slug && (
        <Link to={slug}>
          <img
            src={
              isHqSuite
                ? require("../../images/icons/map-marker-hq-suites.svg").default
                : require("../../images/icons/map-marker.svg").default
            }
            alt={text}
            id={`marker_${id}`}
            className={"custom-map-marker"}
          />
          <Tooltip
            placement="top"
            isOpen={tooltipOpen}
            target={`marker_${id}`}
            toggle={toggle}
          >
            {text}
          </Tooltip>
        </Link>
      )}
      {!slug && !url && (
        <>
          <img
            src={
              isHqSuite
                ? require("../../images/icons/map-marker-hq-suites.svg").default
                : require("../../images/icons/map-marker.svg").default
            }
            alt={text}
            id={`marker_${id}`}
            className={"custom-map-marker"}
          />
          <Tooltip
            placement="top"
            isOpen={tooltipOpen}
            target={`marker_${id}`}
            toggle={toggle}
          >
            {text}
          </Tooltip>
        </>
      )}
    </p>
  )
}

export { Map, Marker }

Map.propTypes = {
  children: PropTypes.node,
}

Marker.propTypes = {
  text: PropTypes.string,
  url: PropTypes.string,
  className: PropTypes.string,
  selected: PropTypes.bool,
}
